import { useEffect } from "react";
import { Grid, Paper, Button } from "@mui/material";
import PersonalizaExperienciasAprendizajeCardImg from "../../components/UmmIApps/Cards/PersonalizaExperienciasAprendizajeCardImg.png";
import GetGrados from "../../data/GetGrados";
import GetMaterias from "../../data/GetMaterias";
import ObjetivosAprendizaje from "../../components/Form/Fields/ObjetivosAprendizaje";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import TemaClase from "../../components/Form/Fields/TemaClase";
import TiempoClase from "../../components/Form/Fields/TiempoClase";
import ActividadExperienciaAprendizaje from "../../components/Form/Fields/ActividadExperienciaAprendizaje";
import MetodologiasPreferidas from "../../components/Form/Fields/MetodologiasPreferidas";
import Edad from "../../components/Form/Fields/Edad";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const PersonalizaExperienciasAprendizajePage = () => {
  const {
    objetivosDeAprendizajePorNivel,
    gradoId,
    materiaId,
    objetivosSeleccionados,
    setObjetivosSeleccionados,
    setPromptData,
    promptData,
    handleAsignaturaChange,
    handleGradoChange,
    handleBack,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleInitialPromptData,
  } = useActividadesContext();

  useEffect(() => {
    const init = {
      nivel: "",
      objetivos: [],
      materia: "",
      tema: "",
      caracterizacion: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      metodologias: "",
      edad: 4,
      tiempo_clase: 45,
    };
    handleInitialPromptData(init, "personaliza_experiencias_aprendizaje");
    setTextoInicial(
      " Aquí tienes las adaptaciones sugeridas para tus actividades. Recuerda que puedes revisar y editar cualquier aspecto para ajustarlo a tu contexto. Si necesitas más ajustes, puedes volver a “Mostrar campos” para personalizar las entradas, pedirle a UmmIA que “Vuelva a generar” las sugerencias o “Copiar” las adaptaciones para integrarlas directamente en tus materiales."
    );
  }, []);

  const colorIconBack = "#278C62";

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={PersonalizaExperienciasAprendizajeCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Personaliza experiencias de aprendizaje"
        description="Modifica de forma sencilla tus ideas o actividades para adaptarlas al contexto, las características de tus estudiantes, las necesidades específicas de tu aula y las metodologías de cada experiencia educativa que implementes."
        isButtonDisabled={false}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ m: 2, mb: 4 }}>
            <GetGrados
              onGradoChange={handleGradoChange}
              selectedGrado={gradoId}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ m: 2, mb: 4 }}>
            <GetMaterias
              gradoId={gradoId}
              onMateriaChange={handleAsignaturaChange}
              selectedMateria={materiaId}
              objetivos={objetivosDeAprendizajePorNivel}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper elevation={3} sx={{ p: 5, mb: 4 }}>
            <ObjetivosAprendizaje
              materiaId={materiaId}
              gradoId={gradoId}
              setPromptData={setPromptData}
              objetivos={objetivosDeAprendizajePorNivel}
              objetivosSeleccionados={objetivosSeleccionados}
              setObjetivosSeleccionados={setObjetivosSeleccionados}
            />
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <TemaClase />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <TiempoClase promptData={promptData} setPromptData={setPromptData} />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <ActividadExperienciaAprendizaje
            promptData={promptData}
            setPromptData={setPromptData}
          />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>

        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <AdaptacionesCurriculares />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <MetodologiasPreferidas
                promptData={promptData}
                setPromptData={setPromptData}
              />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Edad />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default PersonalizaExperienciasAprendizajePage;
